import { useCallback, useContext, useEffect, useMemo, useState } from 'react';

import CustomListView from 'components/ListView/Listview.cmp';
import { columns, defaultColDef, rowHeight } from './constants';
import { ListCnt } from './list.style';
import { useQuery, useQueryClient } from 'react-query';
import { useWorkspaceHook } from 'utils/CustomHooks/useWorkspaceHook';
import { IDashboardItem, IDashboardList } from 'pages/Dashboards/interfaces';
import { QUERY_KEYS } from 'api/constants';
import { getAllDashboards } from 'api/dashboards';
import DashboardMainEmptyState from 'pages/Dashboards/EmptyState/mainEmptyState';

interface IActionDropodwnProps {
  onDeleteCallback: (dashboardId: string) => void;
}
interface IColsProps {
  actionDropodwnProps: IActionDropodwnProps;
}
function CustomDashboardsList({ searchQuery = '' }) {
  const { navigateWithWorkspaceUrl } = useWorkspaceHook();

  const dashboardsQuery = useQuery({
    queryKey: [QUERY_KEYS.GET_DASHBOARDS],
    queryFn: getAllDashboards,
    refetchOnMount: true,
  });

  useEffect(() => {
    dashboardsQuery.refetch();
  }, []);

  // For delete, update the query cache
  const queryClient = useQueryClient();
  const onDeleteCallback = (dashboardId) => {
    queryClient.setQueryData([QUERY_KEYS.GET_DASHBOARDS], (oldData: any) => {
      return {
        ...oldData,
        dashboards: oldData?.dashboards?.filter(
          (item) => item.id !== dashboardId,
        ),
      };
    });
  };

  const columnProps = {
    actionDropodwnProps: { onDeleteCallback, type: 'customDashboards' },
  };
  const colConfig = useMemo(() => columns(columnProps), []);

  const dashboardsData = dashboardsQuery.data?.dashboards || [];
  const filteredDashboards = dashboardsData.filter((item) =>
    item.title.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  if (dashboardsQuery.isLoading) return null; // or a loader
  if (!dashboardsData.length) return <DashboardMainEmptyState />;

  return (
    <ListCnt>
      <CustomListView
        rootProps={{
          style: {
            height: 'calc(100vh - 200px)',
            boxShadow: 'none',
            border: '1px solid #d3d3d382',
            borderRadius: 8,
            overflow: 'hidden',
          },
        }}
        onRowClick={(item) => navigateWithWorkspaceUrl(`/dashboards/${item}`)}
        gridProps={{
          rowData: searchQuery ? filteredDashboards : dashboardsData,
          ref: (ref) => {
            globalThis.dashboardsListView = ref;
          },
          onGridSizeChanged: (event) => event.api.sizeColumnsToFit(),
          headerHeight: 30,
          suppressChangeDetection: true,
          defaultColDef,
          columnDefs: colConfig,
          suppressCellFocus: true,
          getRowHeight: 100,
          suppressRowClickSelection: true,
          getRowId: (params) => params.data.id,
        }}
      />
    </ListCnt>
  );
}

export default CustomDashboardsList;
